import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import Page from '../../components/page';
import cx from 'classnames';
import MechaListStore from '@src/pages/mecha-list/store';
import BackTopFooter from '@src/business-components/backtop-footer';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const styles = require('./index.less');

const MechaList = () => {
  /**
   * 首页 store
   * @type {MechaListStore}
   */
  const store = useStore(() => new MechaListStore());

  return (
    <React.Fragment>
      <Page id={'mecha-page'} className={cx(styles.mechaListRoot, 'page-main')} store={store.pageStore}>
        <div className={styles.titleBox}>
          <div className={styles.title} style={{ backgroundImage: `url(${require('./images/' + getLanguageByPath() + '/page-title.png')})` }} />
          <div className={styles.lineLeft} />
          <div className={styles.lineRight} />
          <div className={styles.triangle} />
          <div className={styles.light} />
          <div className={styles.gang} />
        </div>
        <div className={styles.mechList}>
          {store?.mechaList?.length > 0 &&
            store.mechaList?.map((item, index) => {
              return (
                <div
                  className={styles.mechaItem}
                  key={item.id}
                  onClick={() => store.onRedirectToDetail(item?.mecha_id)}
                  style={{ animationDelay: `${index * 0.1 + 0.5}s` }}
                >
                  <div className={styles.borderHover} />
                  <div className={styles.back} />
                  <div className={styles.backHover} />
                  {item.mecha_list_tab_image ? <div className={styles.mechaImg} style={{ backgroundImage: `url(${item.mecha_list_tab_image})` }} /> : null}
                  <div className={styles.border} />
                  <div className={styles.lineBox}>
                    <div className={styles.leftLine1} />
                    <div className={styles.leftLine2} />
                    <div className={styles.leftLine3} />
                    <div className={styles.rightLine1} />
                    <div className={styles.rightLine2} />
                    <div className={styles.rightLine3} />
                  </div>
                  <div className={styles.nameImg}>
                    <p>{item.mecha_name}</p>
                    <p>{item.mecha_number}</p>
                  </div>
                </div>
              );
            })}
        </div>
        <BackTopFooter />
      </Page>
    </React.Fragment>
  );
};

export default observer(MechaList);
